//==============================
// Hero
//==============================

$('.hero-scroll').click(function() {
  var heroScroll = $(this);
  var nextElement = heroScroll.parent('.hero').next().offset().top;
  $('html, body').animate({ scrollTop: nextElement }, 800);
  return false;
});
